var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-button",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showScrollTopButton,
          expression: "showScrollTopButton",
        },
      ],
      staticClass: "scroll-to-top",
      attrs: { variant: "primary" },
      on: { click: _vm.scrollToTop },
    },
    [_vm._v("\n  Top\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }